import React, { useState } from 'react';
import { Check, ChevronsUpDown, Search } from 'lucide-react';
import { Button } from '../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../ui/command';
import { cn } from '../../lib/utils';

/**
 * Searchable teacher/staff picker (type to filter by name or code).
 * teachers: [{ id, name, code, mobile }]
 */
export const TeacherPicker = ({ teachers = [], value, onChange, placeholder = 'Select teacher', className, testId = 'teacher-picker' }) => {
  const [open, setOpen] = useState(false);
  const selected = teachers.find((tc) => tc.id === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open}
          className={cn('w-56 justify-between font-normal', className)} data-testid={testId}>
          <span className={cn('truncate', !selected && 'text-muted-foreground')}>
            {selected ? selected.name : placeholder}
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[280px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search teacher..." data-testid={`${testId}-search`} />
          <CommandList>
            <CommandEmpty>No teacher found.</CommandEmpty>
            <CommandGroup>
              {teachers.map((tc) => (
                <CommandItem
                  key={tc.id}
                  value={`${tc.name || ''} ${tc.code || ''} ${tc.mobile || ''}`}
                  onSelect={() => { onChange(tc.id); setOpen(false); }}
                  data-testid={`${testId}-item-${tc.id}`}
                >
                  <Check className={cn('mr-2 h-4 w-4', value === tc.id ? 'opacity-100' : 'opacity-0')} />
                  <span className="truncate">{tc.name}</span>
                  {tc.code && <span className="ml-auto text-xs text-muted-foreground">{tc.code}</span>}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
